import { useTranslation } from '@eti/providers';
import { useEffect } from 'react';
import { CHECK_IN_BAGGAGE } from '../../../products';
import { usePersuasionModal } from '../../../common/context/PersuasionModalContext';
import ProductModal from '../../../common/components/ProductModal';
import { jsx as _jsx } from "react/jsx-runtime";
const productName = CHECK_IN_BAGGAGE.name;
const CheckInBaggagePrimaryFlowPersuasionModal = _ref => {
  let {
    submitForm,
    triggerChange
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    isOpen,
    onConfirm,
    onDecline,
    setIsOpen,
    setOnConfirm,
    setOnDecline
  } = usePersuasionModal();
  useEffect(() => {
    if (!isOpen) {
      setIsOpen(true);
    }
    if (isOpen) {
      setOnConfirm(() => async () => {
        await triggerChange('true');
        setIsOpen(false);
        submitForm();
      });
      setOnDecline(() => async () => {
        await triggerChange('false');
        setIsOpen(false);
        submitForm();
      });
    }
  }, [isOpen, setIsOpen, setOnConfirm, setOnDecline, submitForm, triggerChange]);
  return /*#__PURE__*/_jsx(ProductModal, {
    content: t('Product.CheckInBaggage.CD.Persuasion.Content'),
    isOpen: isOpen,
    onConfirm: onConfirm,
    onDecline: onDecline,
    productName: productName,
    title: t('checkInBaggageHeaderTitle')
  });
};
export default CheckInBaggagePrimaryFlowPersuasionModal;
//# sourceMappingURL=CheckInBaggagePrimaryFlowPersuasionModal.js.map